import { motion } from "framer-motion";

// Line-by-line masked reveal. Pass an array of lines (strings or JSX).
export function LineReveal({ lines, className = "", lineClass = "", delay = 0, once = true }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once, margin: "-60px" }}
            transition={{
              duration: 1,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * 0.09,
            }}
            className={lineClass}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 24, once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
